import {useQuery} from '@tanstack/react-query';
import {fetchUserMeetups} from '../endpoints/api';

export const useFetchMeetups = () => {
  return useQuery({
    queryKey: ['user-meetups'],
    queryFn: fetchUserMeetups,
  });
};